import React, { useState, Component, useEffect } from "react";
import useStyles from "./styles";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import MaterialTable from "material-table";
import AirportShuttleOutlinedIcon from "@material-ui/icons/AirportShuttleOutlined";
import AccountBalanceWalletIcon from "@material-ui/icons/AccountBalanceWallet";
import LoyaltyIcon from "@material-ui/icons/Loyalty";
import { Link, useHistory } from "react-router-dom";
import EditIcon from "@material-ui/icons/Edit";
import QuestionAnswerIcon from "@material-ui/icons/QuestionAnswer";
import LibraryAddIcon from "@material-ui/icons/LibraryAdd";
import Box from "@material-ui/core/Box";
import Tab from "@material-ui/core/Tab";
import TabContext from "@material-ui/lab/TabContext";
import TabList from "@material-ui/lab/TabList";
import TabPanel from "@material-ui/lab/TabPanel";
import SpeakerNotesIcon from '@material-ui/icons/SpeakerNotes';

import { useUserContext } from "../../../context/UserContext";
import api from "../../../Axios/api";
// MUI Components
import { Grid, Typography, Button, Avatar, Paper } from "@material-ui/core";
import pal from "../../../themes/palette";

export default function Orders() {
  const [value, setValue] = React.useState("1");
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const classes = useStyles();
  const history = useHistory();
  const [allOrders, setAllOrders] = useState();
  // context
  const { store } = useUserContext();
  const token = store.data.token;

  const columns = [
    {
      title: "Sr#",
      field: "tableData.id",
      render: ({ tableData }) => <div>{tableData.id + 1}</div>,
      hidden: false,
      export: false,
    },
    {
      title: "Order #",
      field: "_id",
    },
    {
      title: "Date",
      field: "createdAt",
      render: ({ createdAt }) => <div>{createdAt.split("T")[0]}</div>,
    },
    {
      title: "Store",
      field: "storeName",
    },

    {
      title: "Total Price",
      field: "totalPrice",
    },
    // {
    //   title: "Discount",
    //   field: "totalDiscount",
    // },

    {
      title: "Quantity",
      field: "totalQuantity",
    },
    {
      title: "Paid By",
      field: "paymentMethod",
      render: ({ paymentMethod }) => (
        <div>{paymentMethod ? paymentMethod : "Cash"}</div>
      ),
    },
    {
      title: "Status",
      field: "status",
    },
    {
      title: "Actions",
      render: ({ storeId, _id, storeName,status }) => (
        
        <Button
        onClick={()=>history.push(`/reportOrderProblem?storeId=${storeId}&orderId=${_id}&storeName=${storeName}`)}
        disabled={status != "Delivered"} color="primary" variant="contained"> <SpeakerNotesIcon style={{marginRight:4}}/>Report
        </Button>
      ),
    },
    
  ];
  const retrivingAllOrders = async () => {
    await api
      .get("/buyer/orders/me", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        // console.log('orders', res.data.data.orders)
        setAllOrders(res.data.data.orders);
      })
      .catch((error) =>
        console.log("ERROR: " + JSON.stringify(error.response.data.error))
      );
  };

  const retrivingActiveOrders = async () => {
    await api
      .get("/buyer/orders/Active", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        // console.log('orders', res.data.data.orders)
        setAllOrders(res.data.data.orders);
      })
      .catch((error) =>
        console.log("ERROR: " + JSON.stringify(error.response.data.error))
      );
  };

  const retrivingPendingOrders = async () => {
    await api
      .get("/buyer/orders/Pending", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        // console.log('orders', res.data.data.orders)
        setAllOrders(res.data.data.orders);
      })
      .catch((error) =>
        console.log("ERROR: " + JSON.stringify(error.response.data.error))
      );
  };

  const retrivingDeliveredOrders = async () => {
    await api
      .get("/buyer/orders/Delivered", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        // console.log('orders', res.data.data.orders)
        setAllOrders(res.data.data.orders);
      })
      .catch((error) =>
        console.log("ERROR: " + JSON.stringify(error.response.data.error))
      );
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    if (value === "1") {
      retrivingAllOrders();
    }

    if (value === "2") {
      retrivingActiveOrders();
    }

    if (value === "3") {
      retrivingPendingOrders();
    }

    if (value === "4") {
      retrivingDeliveredOrders();
    }
  }, [value]);

  const renderTable = (tableName) => {
    return (
      <div>
        <MaterialTable
          title={tableName}
          data={allOrders}
          columns={columns}
          options={{
            actionsColumnIndex: -1,
            headerStyle: {
              backgroundColor: pal.palette.primary.main,
              color: "#fff",
              whiteSpace: "nowrap",
            },

            tableLayout: "auto",
            pagination: "false",
          }}
          detailPanel={(rowData) => {
            return (
              <div style={{ padding: "20px 40px" }}>
                <Typography
                  variant="h6"
                  style={{
                    fontWeight: "bold",
                    marginBottom: 10,
                  }}
                >
                  Ordered Items:
                </Typography>
                <Grid container spacing={2}>
                  {rowData.products.map((prod, index) => (
                    <Grid item xs={12} key={prod._id}>
                      <Grid
                        container
                        spacing={4}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginBottom: 5,
                        }}
                      >
                        <Grid
                          item
                          style={{
                            display: "flex",
                          }}
                        >
                          <div
                            style={{
                              marginRight: 20,
                            }}
                          >
                            {index + 1 + ". "}
                          </div>
                          <div>
                            <Typography>
                              PID:{" "}
                              <span style={{ fontWeight: "bold" }}>
                                {prod.productId}
                              </span>
                            </Typography>
                            <Typography>
                              Name:{" "}
                              <span style={{ fontWeight: "bold" }}>
                                {prod.name}
                              </span>
                            </Typography>
                            <Typography>
                              Size:{" "}
                              <span style={{ fontWeight: "bold" }}>
                                {prod.size ? prod.size : "Not Specified"}
                              </span>
                            </Typography>
                            <Typography>
                              Color:{" "}
                              <span style={{ fontWeight: "bold" }}>
                                {prod.color ? prod.color : "Not Specified"}
                              </span>
                            </Typography>
                            <Typography>
                              Quantity:{" "}
                              <span style={{ fontWeight: "bold" }}>
                                {prod.quantity}
                              </span>
                            </Typography>
                            <div>
                            <Typography>
                              Price:{" "}
                              <span color="primary" style={{ fontWeight: "bold" }}>
                                {prod.salePrice}
                              </span>
                            </Typography>
                            <Typography>
                              Discount:{" "}
                              <span style={{ fontWeight: "bold" }}>
                                {prod.discountedPrice
                                  ? prod.discountedPrice
                                  : 0}
                              </span>
                            </Typography>
                          </div>
                          </div>
                        </Grid>
                      </Grid>
                    </Grid>
                  ))}
                </Grid>
              </div>
            );
          }}
        />
      </div>
    );
  };

  return (
    <div>
      <div className={classes.mainAboutusContainer}>
        <Breadcrumbs
          style={{ paddingTop: 30, paddingBottom: 20 }}
          aria-label="breadcrumb"
        >
          <Link className={classes.bCrumbLink} style={{ color: "grey" }} to="/">
            Home
          </Link>
          <Link
            className={classes.bCrumbLink}
            style={{ color: "grey" }}
            to="/account"
          >
            My Account
          </Link>
          <Typography color="textPrimary">My Orders </Typography>
        </Breadcrumbs>

        <div>
          <Grid container spacing={1} style={{ margin: "0px 0px 0px 0px" }}>
            <Grid item xs={12} sm={12} md={12} component={Paper}>
              <div className={classes.paper}>
                <Avatar className={classes.avatar}>
                  <LibraryAddIcon />
                </Avatar>
                <Typography variant="h5">My Orders</Typography>
                <Box
                  sx={{ width: "100%", typography: "body1" }}
                  style={{ marginTop: 15 }}
                >
                  <TabContext value={value}>
                    <Box
                      sx={{
                        borderBottom: 1,
                        borderColor: "divider",
                        color: "#EF233C",
                      }}
                    >
                      <TabList
                        onChange={handleChange}
                        aria-label="lab API tabs example"
                        TabIndicatorProps={{ style: { background: "#EF233C" } }}
                      >
                        <Tab label="All" value="1" />
                        <Tab label="Active" value="2" />
                        <Tab label="Pending" value="3" />
                        <Tab label="Received" value="4" />
                      </TabList>
                    </Box>
                    <TabPanel style={{padding:3}} className={classes.tabStyle} value="1">{renderTable("All Orders")}</TabPanel>
                    <TabPanel style={{padding:3}} className={classes.tabStyle} value="2">{renderTable("Active Orders")}</TabPanel>
                    <TabPanel style={{padding:3}} className={classes.tabStyle} value="3">{renderTable("Pending Orders")}</TabPanel>
                    <TabPanel style={{padding:3}} className={classes.tabStyle} value="4">{renderTable("Received Orders")}</TabPanel>
                  </TabContext>
                </Box>
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={12} component={Paper}></Grid>
          </Grid>
        </div>
      </div>
    </div>
  );
}